export const inr = (n) => `\u20B9${Number(n).toLocaleString("en-IN")}`;
